import {CfgArClaimProcessorForLocation} from './cfg-ar-claim-processor-for-location';

export class CfgArClaimProcessorForLocationsListModel extends CfgArClaimProcessorForLocation{
  Name: string;
  isProcessorLocation: boolean;
}
